import { routes, router } from "../../app/routes";
import { useParams } from "react-router-dom";
import SubmenuSideBar from "../../components/sideBar/SubmenuSideBar";
import { TubingService, UrlService, UserService } from "../../services";
import { Button } from "react-bootstrap";
import { useSharedState } from "../../app/sharedProperty";
import { SlideOutModal } from "../../components/modals/SlideOutModal";
import { showErrorMessage, showSuccessMessage } from "../../app/tools";
import { Roles, SubmenuSideBarNavItemModel } from "../../models";

export function TubingSidebar() {

  const urlParams = useParams();
  const tubingId = parseInt(UrlService.getParamValue("id", urlParams) ?? "0");
  const isAdmin = UserService.isInRole(Roles.admin);

  const showSelectModalState = useSharedState(false);

  const selectModalCancelClick = () => {
    showSelectModalState.setter(false);
  };

  const deleteSelectClick = async () => {
    if(!isAdmin) {
      showErrorMessage(`You do not have permission to delete this tubing.`);
      showSelectModalState.setter(false);
      return;
    }
    try {
      await new TubingService().deleteTubing(tubingId);
      showSuccessMessage(`Tubing successfully deleted.`);
      router.navigate(routes.tubings);
    }
    catch (error) {
      showErrorMessage(`Failed to delete tubing.`);
      console.error(error);
      showSelectModalState.setter(false);
      return;
    }
  };

  const menuItems = [
    {
      text: 'Details',
      url: router.getUrl(routes.tubingDetails, new Map([
        ['Id', tubingId.toString()]
      ])),
      activeMatchUrl: routes.tubingDetails,
      additionalClass: "submenu-sidebar-nav-item",
      isTubingsMenu: true
    },
    {
      text: 'Inspections',
      url: router.getUrl(routes.tubingInspections, new Map([
        ['Id', tubingId.toString()]
      ])),
      activeMatchUrl: routes.tubingInspections,
      additionalClass: "submenu-sidebar-nav-item",
      isTubingsMenu: true
    },
    {
      text: 'Mill Cert',
      url: router.getUrl(routes.tubingMillCert, new Map([
        ['Id', tubingId.toString()]
      ])),
      activeMatchUrl: routes.tubingMillCert,
      additionalClass: "submenu-sidebar-nav-item",
      isTubingsMenu: true
    },
    isAdmin ? {
      text: 'Delete',
      url: "",
      additionalClass: "submenu-sidebar-nav-item",
      clickHandler: () => showSelectModalState.setter(true),
    } : null
  ].filter(Boolean) as SubmenuSideBarNavItemModel[];

  return (
    <>
      <SubmenuSideBar menuItems={menuItems} />
      <SlideOutModal
        showState={showSelectModalState}
        title={"Delete Tubing"}
        footer={<>
          <Button onClick={selectModalCancelClick} variant="primary" className="w-100">
            Close
          </Button>
          <Button onClick={deleteSelectClick} variant="secondary" className="w-100">
            Delete
          </Button>
        </>}
      >
        Are you sure you want to delete this tubing?
      </SlideOutModal>
    </>
  );
}

export default TubingSidebar;
